(() => {
  if (customElements.get('mp-navigation')) return;
  customElements.define('mp-navigation', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.details = this.querySelector('.mp-menu');
      this.trigger = this.details.querySelector(':scope > summary');
      this.panel = this.querySelector('.mp-menu__panel');
      this.header = this.closest('.section-header');
      this.locked = false;
      this.dataset.ready = 'true';
      this.trigger.setAttribute('aria-expanded', 'false');
      this.trigger.addEventListener('click', event => {
        event.preventDefault();
        this.details.open ? this.close() : this.open();
      }, options);
      this.querySelector('[data-menu-close]').addEventListener('click', () => this.close(), options);
      this.querySelector('[data-menu-backdrop]').addEventListener('click', () => this.close(), options);
      this.details.addEventListener('toggle', () => {
        if (this.details.open !== this.locked) this.details.open ? this.open() : this.close(false);
      }, options);
      this.querySelectorAll('[data-menu-group]').forEach(group => {
        const summary = group.querySelector(':scope > summary');
        summary.setAttribute('aria-expanded', String(group.open));
        summary.addEventListener('click', () => {
          if (!group.open) {
            group.parentElement.parentElement.querySelectorAll(':scope > li > [data-menu-group]').forEach(sibling => {
              if (sibling !== group) sibling.open = false;
            });
          }
        }, options);
        group.addEventListener('toggle', () => {
          summary.setAttribute('aria-expanded', String(group.open));
          if (!group.open) group.querySelectorAll('details[open]').forEach(child => { child.open = false; });
        }, options);
      });
      document.addEventListener('keydown', event => this.onKey(event), options);
      document.addEventListener('focusin', event => {
        if (this.locked && !this.panel.contains(event.target)) this.panel.querySelector('[data-menu-close]').focus();
      }, options);
      window.addEventListener('resize', () => {
        requestAnimationFrame(() => requestAnimationFrame(() => {
          if (this.locked && !this.trigger.getClientRects().length) this.close(false);
        }));
      }, options);
      window.addEventListener('pagehide', () => this.close(false), options);
      this.panel.querySelectorAll('a[href]').forEach(link => link.addEventListener('click', event => {
        if (!event.ctrlKey && !event.metaKey && !event.shiftKey && link.target !== '_blank') this.close(false);
      }, options));
    }
    open() {
      if (this.locked) return;
      this.locked = true;
      this.details.open = true;
      this.details.classList.add('menu-opening');
      this.trigger.setAttribute('aria-expanded', 'true');
      this.header?.classList.add('menu-open');
      this.previousScroll = window.scrollY;
      this.bodyStyles = { position: document.body.style.position, top: document.body.style.top, width: document.body.style.width };
      document.body.classList.add('mp-menu-is-open');
      document.body.style.position = 'fixed';
      document.body.style.top = `-${this.previousScroll}px`;
      document.body.style.width = '100%';
      this.inertSiblings = [];
      let current = this;
      while (current.parentElement && current !== document.body) {
        for (const sibling of current.parentElement.children) {
          if (sibling !== current && sibling instanceof HTMLElement && !sibling.inert && !['SCRIPT', 'STYLE', 'LINK'].includes(sibling.tagName)) {
            sibling.inert = true;
            this.inertSiblings.push(sibling);
          }
        }
        current = current.parentElement;
      }
      // Focus the close control rather than opening the phone keyboard immediately.
      this.panel.querySelector('[data-menu-close]').focus({ preventScroll: true });
    }
    close(restoreFocus = true) {
      if (!this.locked) return;
      this.locked = false;
      this.details.open = false;
      this.details.classList.remove('menu-opening');
      this.trigger.setAttribute('aria-expanded', 'false');
      this.header?.classList.remove('menu-open');
      this.inertSiblings.forEach(element => { element.inert = false; });
      document.body.classList.remove('mp-menu-is-open');
      Object.assign(document.body.style, this.bodyStyles);
      window.scrollTo({ top: this.previousScroll, behavior: 'instant' });
      if (restoreFocus && this.trigger.getClientRects().length) this.trigger.focus({ preventScroll: true });
    }
    onKey(event) {
      if (!this.locked) return;
      if (event.key === 'Escape') {
        event.preventDefault();
        event.stopPropagation();
        this.close();
      } else if (event.key === 'Tab') {
        const focusable = [...this.panel.querySelectorAll('a[href], button, input, select, summary, [tabindex="0"]')]
          .filter(element => !element.disabled && element.getClientRects().length);
        const first = focusable[0], last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
        else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
      }
    }
    disconnectedCallback() {
      this.close(false);
      this.controller?.abort();
      this.controller = null;
    }
  });
})();
